import { Controller } from '@hotwired/stimulus';

export default class MerchandisePurchaseText extends Controller {
  static targets = [
    'checkbox',
    'count',
    'amount',
    'submit'
  ];

  connect() {
    this.toggleCheckbox();
  }

  toggleCheckbox() {
    const selected = this.checkboxTargets.filter(el => el.checked);
    const amount   = selected.reduce((acc, el) => acc + Number(el.dataset.amount), 0);

    this.countTarget.textContent  = selected.length;
    this.amountTarget.textContent = Intl.NumberFormat('ja-JP').format(amount);
    this.submitTarget.disabled    = selected.length === 0;
  }
}
